var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseWhite = function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.032 0 6 4.968 10.968 0 12 1.032 7.032 6 12 10.968 10.968 12 6 7.032 1.032 12 0 10.968 4.968 6 0 1.032 1.032 0Z",
    fill: "#fff"
  })));
};
export { SvgCloseWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMDMyMjYgMEw2IDQuOTY3NzRMMTAuOTY3NyA0LjI2Mzg1ZS0wN0wxMiAxLjAzMjI2TDcuMDMyMjYgNkwxMiAxMC45Njc3TDEwLjk2NzcgMTJMNiA3LjAzMjI2TDEuMDMyMjYgMTJMMCAxMC45Njc3TDQuOTY3NzQgNkw4Ljg5NTY2ZS0xMCAxLjAzMjI2TDEuMDMyMjYgMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";